import React from 'react'
import Layout from '../layout/Layout'

export default function Product() {
    return (
        <Layout>
            <h1>Product</h1>
        </Layout>
    )
}
